import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import GridContainer from './../shared/GridContainer'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import { withStyles } from '@material-ui/core'

import PageSelector from './shared/PageSelector'
import Comparator from './tourist_source/Comparator'
import MapVisualizer from './shared/MapVisualizer'
import DataVisualizer from './shared/DataVisualizer'

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { touristSourceData, touristSourceSetCurrentSelection } from './../../actions';

import './TouristSource.css'
import { comparatorDataFilter } from '../../libs/DataUtilities'

const styles = theme => ({
    responsiveDirection: {
        [theme.breakpoints.down('xs')]: {
          flexDirection: 'column-reverse',
        }
    }
});

class TouristSource extends Component {

    /* Methods */

    getMapVisualizerShownState = (mapVisualizerIndex) => { return this.props.touristSourceState.mapVisualizerStates[mapVisualizerIndex] || {} }

    /* Lifecycle */

    componentDidMount() {
        this.props.actions.touristSourceData(
            data => console.log(data),
            error => console.log(error)
        )
    }
    
    render() {

        const { classes, comparators, touristSourceData, touristSourceState } = this.props
        const { touristSourceSetCurrentSelection } = this.props.actions

        return (
            <div className="pages-tourist-source">
                <GridContainer>
                    <Grid item xs={12}>
                        <PageSelector/>
                        <Typography variant="body1">
                            { this.context.t('tourist_source.text') }
                        </Typography>
                        <br />
                    </Grid>
                    <Grid item xs={12}>
                        <Comparator/>
                        <br />
                    </Grid>
                    {
                        comparators.map((comparator, index) => {
                            const filteredData = comparatorDataFilter(touristSourceData, comparator.region, comparator.dataType, comparator.source)
                            const gridDivisor = comparators.length > 1 ? 2 : 1

                            const mapVisualizer = <MapVisualizer region={comparator.region} 
                                                                 shownDataType={this.getMapVisualizerShownState(index).shownDataType}
                                                                 shownSource={this.getMapVisualizerShownState(index).shownSource}
                                                                 data={filteredData} 
                                                                 currentSelection={touristSourceState.currentSelection}
                                                                 currentSelectionChange={touristSourceSetCurrentSelection}
                                                                 index={index}/>

                            const dataVisualizer = <DataVisualizer comparator={comparator} 
                                                                   data={filteredData} 
                                                                   currentSelection={touristSourceState.currentSelection}
                                                                   currentSelectionChange={touristSourceSetCurrentSelection}/>

                            return (
                                <Grid key={index} item sm={12 / gridDivisor} xs={12}>
                                    {
                                        gridDivisor > 1
                                            ? (
                                                <Grid container>
                                                    <Grid item sm={6 * gridDivisor} xs={12}>
                                                        { mapVisualizer }
                                                    </Grid>
                                                    <Grid item sm={6 * gridDivisor} xs={12}>
                                                        { dataVisualizer }
                                                    </Grid>
                                                </Grid>
                                            )
                                            : (
                                                <Grid className={classes.responsiveDirection} container>
                                                    <Grid item sm={6 * gridDivisor} xs={12}>
                                                        { dataVisualizer }
                                                    </Grid>
                                                    <Grid item sm={6 * gridDivisor} xs={12}>
                                                        { mapVisualizer }
                                                    </Grid>
                                                </Grid>
                                            )
                                    }
                                    
                                </Grid>
                            )
                        })
                    }
                    <Grid item xs={12}>
                        <Typography variant="body1">
                            { this.context.t('shared.deepening_text') }
                            <br/>
                            <br/>
                            <Link to="/deepening">{ this.context.t('shared.deepening_link') }</Link>
                        </Typography>
                        <br />
                    </Grid>
                </GridContainer>
            </div>
        )
    }
}

TouristSource.contextTypes = {
    t: PropTypes.func
}

function mapStateToProps(state) {
    return {
        touristSourceState: state.touristSourceState,
        touristSourceData: state.touristSourceData.data,
        touristSourceDataLoading: state.touristSourceData.loading,
        comparators: state.touristSourceComparator.comparators
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            touristSourceData: bindActionCreators(touristSourceData, dispatch),
            touristSourceSetCurrentSelection: bindActionCreators(touristSourceSetCurrentSelection, dispatch)
        }
    }
}

const StyledTouristSource = withStyles(styles)(TouristSource)

export default connect(mapStateToProps, mapDispatchToProps)(StyledTouristSource)


// WEBPACK FOOTER //
// ./src/components/pages/TouristSource.js